import Home from './Home'
import ErrPage from './ErrPage'
import Hello from './HelloWorld'
import {UserInfo, User, MemberRights, UpdateUserInfo, UpdatePhone} from './user'
import {CommitDoc, DocModule, ModuleDetail, SubDoc, ServiceOrder, Lawsuit, LawyerLetter, MeetConsult, DraftDoc} from './doc'
import {OrderList, TelDetail, DocDetail, OrderEvaluate, LetterDetail, LawsuitDetail, FaceDetail, DraftDetail} from './order'
import * as cards from './card'
import {SubTel, PhoneWaiting, Payment, UnLinkReason, UnLinkResearch, LawyerWaiting, PayWaiting, PaySuccess, LawyerEvaluation} from './telephone'
import {ServiceMall} from './servicemall'
import {Lawyer} from './lawyer'
import {Information} from './information'

const routers = {
  Home,
  Hello,
  UserInfo,
  User,
  MemberRights,
  UpdateUserInfo,
  UpdatePhone,
  CommitDoc,
  DocModule,
  OrderList,
  TelDetail,
  DocDetail,
  DraftDetail,
  ModuleDetail,
  SubDoc,
  OrderEvaluate,
  LetterDetail,
  LawsuitDetail,
  FaceDetail,
  ...cards,
  SubTel,
  Lawsuit,
  LawyerLetter,
  MeetConsult,
  DraftDoc,
  PhoneWaiting,
  Payment,
  UnLinkReason,
  UnLinkResearch,
  ServiceOrder,
  ServiceMall,
  Lawyer,
  Information,
  LawyerWaiting,
  PayWaiting,
  PaySuccess,
  LawyerEvaluation,
  ErrPage
}

let modules = {}

export {
  routers,
  modules
}



// WEBPACK FOOTER //
// ./src/pages/index.js